/**
 * Great-circle (haversine) distance between two geographic points.
 * Returns meters along a sphere of radius 6 371 008.8 m (WGS-84 mean).
 */
const EARTH_RADIUS_METERS = 6_371_008.8;
export function haversineMeters(latA, lonA, latB, lonB) {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const φ1 = toRad(latA);
    const φ2 = toRad(latB);
    const dφ = toRad(latB - latA);
    const dλ = toRad(lonB - lonA);
    const a = Math.sin(dφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(dλ / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_METERS * c;
}
//# sourceMappingURL=haversine.js.map